import { GET_ACTIVE_DIRECTORY_USERS } from "../actions/actionTypes";

const initialState = {
  adUsers: [],
};

export default function activeDirectoryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ACTIVE_DIRECTORY_USERS: {
      const { data } = action.payload;
      const list = data?.length ? data : [];
      return {
        ...state,
        adUsers: list,
      };
    }

    default:
      return state;
  }
}
